import { render, staticRenderFns } from "./i4pro-range-slider.vue?vue&type=template&id=15cad9d5"
import script from "./i4pro-range-slider.vue?vue&type=script&lang=js"
export * from "./i4pro-range-slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports